<template>
    <div>
        <el-form :inline="true" :model="queryParams"  class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px">
            <el-form-item label="角色名称">
                <el-input v-model="queryParams.roleName" placeholder="请输入角色名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="权限字符">
                <el-input v-model="queryParams.roleKey" placeholder="请输入权限字符" clearable></el-input>
            </el-form-item>
            <el-form-item label="角色状态">
                <el-select v-model="queryParams.status"  placeholder="角色状态">
                    <el-option label="正常" value="0" selected ></el-option>
                    <el-option label="停用" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                        v-model="dateRange"
                        style="width: 240px"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            <el-row>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="selectRole()">查询</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
                </el-form-item>
            </el-row>

        </el-form>


        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="openAddDialog"
                >添加</el-button>
            </el-col>
            <!--            <el-col :span="1.5">-->
            <!--                <el-button-->
            <!--                        type="success"-->
            <!--                        plain-->
            <!--                        icon="el-icon-edit"-->
            <!--                        size="mini"-->
            <!--                >修改</el-button>-->
            <!--            </el-col>-->
            <!--            :disabled="single"-->
            <!--            @click="handleUpdate"-->
            <!--            v-hasPermi="['system:role:edit']"-->
            <el-col :span="1.5">
                <el-button
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        size="mini"
                        @click="delList"
                >删除</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                        type="warning"
                        plain
                        icon="el-icon-download"
                        size="mini"
                        @click="exportList"
                >导出</el-button>
            </el-col>


        </el-row>
        <el-table
                :data="roleList"
                style="width: 100%;margin-bottom: 20px;line-height: 0"
                @selection-change="handleSelectionChange"
                row-key="id"
                show-header
                border>
            <el-table-column type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
            <el-table-column label="角色名称" align="center" prop="roleName" :show-overflow-tooltip="true" width="180" />
            <el-table-column label="权限字符" align="center" prop="roleKey" :show-overflow-tooltip="true" width="180" />
            <el-table-column label="显示顺序" align="center" prop="roleSort" width="120"   />
            <el-table-column label="状态"  align="center" width="150">
                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.status"
                            active-value="0"
                            inactive-value="1"
                            @change="swithStu(scope.row)"
                            :disabled="scope.row.roleKey=='admin'?true:false"
                    ></el-switch>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" align="center" prop="createTime" width="280">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope" v-if="scope.row.roleKey !== 'admin'">
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            @click="modifyButton(scope.row)"
                    >修改</el-button>
                    <!--                    <el-button-->
                    <!--                            size="mini"-->
                    <!--                            type="text"-->
                    <!--                            icon="el-icon-delete"-->
                    <!--                            @click=""-->
                    <!--                    >数据权限</el-button>-->
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-delete"
                            @click="delList(scope.row)"
                    >删除</el-button>
                </template>

            </el-table-column>
        </el-table>
        <template v-if="roleList.length!=0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[1, 2, 5, 10]"
                           :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>


        <!--        这里是添加的角色的弹出框-->
        <el-dialog class="addRoleDialog" :title="title"  :visible.sync="addRoleDialog">
            <el-form :model="addRoleFrom" :rules="rules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :disabled="true" label="角色名称" label-width="80px" prop="roleName">
                            <el-input  v-model="addRoleFrom.roleName" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :disabled="true" label="权限字符" label-width="80px" prop="roleKey">
                            <el-input  v-model="addRoleFrom.roleKey" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :disabled="true" label="角色顺序" label-width="80px" prop="roleSort">
                            <el-input type="number" v-model="addRoleFrom.roleSort" :min="0"  autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态" label-width="80px">
                            <el-radio-group v-model="addRoleFrom.status">
                                <el-radio label="0">正常</el-radio>
                                <el-radio label="1">停用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="菜单权限" label-width="80px">
                    <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event)">展开/折叠</el-checkbox>
                    <el-checkbox v-model="selectAllBox" @change="handleCheckedTreeNodeAll($event)">全选/全不选</el-checkbox>
                    <el-checkbox v-model="addRoleFrom.menuCheckStrictly" @change="handleCheckedTreeConnect($event)">父子联动</el-checkbox>

                    <el-tree
                            class="tree-border"
                            :data="menuForm"
                            show-checkbox
                            ref="menu"
                            :check-on-click-node="true"
                            node-key="menuId"
                            :check-strictly="!addRoleFrom.menuCheckStrictly"
                            empty-text="加载中，请稍候"
                            :props="defaultProps"
                            :default-checked-keys="roleMenus"
                    />
                </el-form-item>
                <el-form-item label="备注" label-width="80px">
                    <el-input type="" v-model="addRoleFrom.remark" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addRoleDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitAdd()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import {ALL_WITH_INDETERMINATE} from "@riophae/vue-treeselect/src/constants";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    export default {
        name: "userManager",
        components: {
            Treeselect
        },
        data() {
            return {
                form: {},
                menuExpand: false,
                deptExpand: false,
                title: "",
                mdDialog: false,
                folderPath: '',
                collapseBox: false,
                selectAllBox: false,
                cascadeBox: true,
                addSelectAllBox: false,
                addCascadeBox: true,
                radio: 0,
                menuForm: [],
                addRoleDialog: false,
                addRoleFrom: {
                    id: null,
                    roleName: null,
                    roleKey: null,
                    roleSort: 0,
                    status: "0",
                    menuIds: [],
                    remark: null
                },
                roleList: [],//菜单
                // 日期范围
                dateRange: [],
                //加载状态
                loading: false,
                total: 0,
                //查询数据
                queryParams: {
                    pageNum: 1,
                    pageSize: 5,
                    roleName: null,
                    roleKey: null,
                    status: null,
                    beginTime: null,
                    endTime: null,
                },
                rules: {
                    roleName: [
                        {required: true, message: '请输入角色名称', trigger: 'blur'},
                        {max: 10, message: '角色名称不能超过10个字符', trigger: 'blur'},
                    ],
                    roleKey: [
                        {required: true, message: '请输入权限字符', trigger: 'blur'},
                        {max: 10, message: '权限字符不能超过10个字符', trigger: 'blur'},
                    ],
                    roleSort: [
                        {required: true, message: '请输入角色显示顺序', trigger: 'blur'},
                        {max: 5, message: '角色显示顺序设置过大', trigger: 'blur'},
                    ],
                },
                selectedRows: [],

                defaultProps: {
                    children: "children",
                    label: "menuName"
                },
                roleMenus: [],//角色下的菜单
            }
        },
        computed: {
            ALL_WITH_INDETERMINATE() {
                return ALL_WITH_INDETERMINATE
            }
        },
        methods: {
            //改变状态
            async swithStu(row) {
                const res = await this.$http.get('role/updateRoleStatus',{params:{
                        roleId:row.id,
                        status:row.status,
                    }});
                if (res.data.code == 200) {
                    if (row.status=='1'){
                        this.$message({
                            message: '角色已禁用！',
                            type: 'success'
                        });
                    }else {
                        this.$message({
                            message: '角色已启用！',
                            type: 'success'
                        });
                    }
                    this.getRoleList();
                } else if (res.data.code==500014){
                    this.$message.error('该角色已被分配，不能关闭状态！')
                    this.getRoleList();
                }else {
                    this.$message.error('状态更新失败');
                }

            },
            // 树权限（展开/折叠）
            handleCheckedTreeExpand(value) {
                let treeList = this.menuForm;
                for (let i = 0; i < treeList.length; i++) {
                    this.$refs.menu.store.nodesMap[treeList[i].menuId].expanded = value;
                }
            },
            // 树权限（全选/全不选）
            handleCheckedTreeNodeAll(value) {
                this.$refs.menu.setCheckedNodes(value ? this.menuForm : []);
            },
            // 树权限（父子联动）
            handleCheckedTreeConnect(value) {
                this.form.menuCheckStrictly = value ? true : false;
            },
            reset(){
                this.addRoleFrom= {
                    id: null,
                    roleName: null,
                    roleKey: null,
                    roleSort: 0,
                    status: "0",
                    remark: null,
                    menuIds: [],
                },
                    this.roleMenus=[]
            },
            //更新按钮处理
            async modifyButton(row) {
                console.log(row)
                this.reset();
                this.addRoleDialog = true;
                this.addRoleFrom = row;
                const {data: res_menus} = await this.$http.get('role/getRoleMenus/' + row.id);
                for (let i = 0; i < res_menus.data.length; i++) {
                    this.roleMenus.push(res_menus.data[i].menuId);
                }
                console.log(this.roleMenus)
                this.$nextTick(function () {
                    //Dom更新完毕
                    this.$refs.menu.setCheckedKeys(this.roleMenus);
                })
                this.title = '更新角色信息';
            },
            async exportList() {
                this.$confirm(`确定要导出吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 用户点击"确定"按钮，执行删除操作
                    this.ex();
                }).catch(() => {
                    // 用户点击"取消"按钮，什么也不做
                    this.$message.info('已取消删除！')
                })
            },
            ex() {
                this.$http.post('role/export', this.selectedRows, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    responseType: 'blob' // 指定响应类型为二进制流
                }).then(res => {
                    // 获取响应数据并进行处理
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', '角色列表.xlsx'); // 设置下载文件名
                    document.body.appendChild(link);
                    link.click();
                });
            },
            async delList(row) {
                if (row.id){
                    this.selectedRows=[];
                    this.selectedRows.push(row.id);
                }
                this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async ()=>{
                    const {data: res} = await this.$http.post("role/deleteRoleByIds", this.selectedRows)
                    // console.log(res)
                    if (res.code == 200) {
                        this.$message.success('删除成功')
                        this.getRoleList()
                    }else if (res.code==50008){
                        this.$message.error('请确保所选择的角色数据是否都没有被分配给用户！')
                    }else {
                        this.$message.error('删除失败')
                    }
                }).catch((e) => {
                    this.$message.info('已取消删除！')
                })

            },
            handleSelectionChange(rows) {
                const newArr = []
                rows.forEach((item) => {
                    newArr.push(item.id)
                });
                this.selectedRows = newArr
                console.log(this.selectedRows)
            },
            async submitAdd() {
                //获取选中的节点
                this.addRoleFrom.menuIds=this.$refs.menu.getCheckedKeys(false,this.roleMenus);
                console.log(this.addRoleFrom)
                if (this.addRoleFrom.id == null) {//添加
                    console.log("添加角色")
                    const {data: res} = await this.$http.post("role/insertRole", this.addRoleFrom)
                    // console.log(res)
                    if (res.code == 200) {
                        this.reset();
                        this.$message.success('添加成功！')
                        this.addRoleDialog = false
                        this.getRoleList();
                    } else if (res.code==50003){
                        this.$message({
                            showClose: true,
                            message: '角色已存在！',
                            type: 'warning'
                        });
                    }else if (res.code==50007){
                        this.$message({
                            showClose: true,
                            message: '权限字符存在！',
                            type: 'warning'
                        });
                    }else {
                        this.$message.error('添加失败！')
                        this.addRoleDialog=false;
                    }
                } else {//修改
                    console.log("更新角色")
                    const {data:res}=await this.$http.post('role/updateRole',this.addRoleFrom);
                    console.log(res.code)
                    if (res.code==200){
                        this.$message.success('更新成功')
                        this.reset();
                        this.getRoleList();
                        this.addRoleDialog = false
                    }else if (res.code==50003){
                        this.$message({
                            showClose: true,
                            message: '角色已存在！',
                            type: 'warning'
                        });
                    }else if (res.code==50007){
                        this.$message({
                            showClose: true,
                            message: '权限字符存在！',
                            type: 'warning'
                        });
                    }else if (res.code==500014){
                        this.$message.error('该角色已被分配，不能停用！')
                        this.getRoleList();
                    }
                }
            },
            async getMenuList() {
                const {data: res} = await this.$http.get('menu/getMenuListByNeed',{params:{menuName:'',status:null}});
                // console.log(res)
                this.menuForm = res.data;
            },
            handleSizeChange(newSize) {
                //pagesize改变时触发，当pagesize发生改变的时候，我们应该
                //以最新的pagesize来请求数据并展示数据
                //   console.log(newSize)
                this.queryParams.pageSize = newSize;
                //重新按照pagesize发送请求，请求最新的数据
                this.getRoleList();
            },
            handleCurrentChange(current) {
                //页码发生改变时触发当current发生改变的时候，我们应该
                //以最新的current页码来请求数据并展示数据
                //   console.log(current)
                this.queryParams.pageNum = current;
                //重新按照pagenum发送请求，请求最新的数据
                this.getRoleList();
            },
            resetQuery() {
                this.queryParams = {
                    pageNum: 1,
                    pageSize: 5,
                    roleName: null,
                    roleKey: null,
                    status: null,
                    beginTime: null,
                    endTime: null,
                }
                this.dateRange = null
                this.getRoleList()
            },
            openAddDialog() {
                this.reset();
                this.addRoleDialog = true;
                this.$refs.menu.setCheckedNodes(this.roleMenus=[]);
                this.title = '新增角色';
            },
            async getRoleList() {
                if (this.dateRange != null) {
                    this.queryParams.beginTime = this.dateRange[0]
                    this.queryParams.endTime = this.dateRange[1]
                }
                // console.log(this.queryParams)
                const {data: res} = await this.$http.get('role/getSysRoleList',{params:this.queryParams});
                // console.log(res)
                this.total = res.data.total;
                this.roleList = res.data.children;
            },
            selectRole() {
                this.getRoleList()
            },
        },
        mounted() {
            this.getRoleList();
            this.getMenuList()
        }

    }

</script>

<style scoped>
    .modifyRoleDialog{
        max-width: 800px; /* 设置最大宽度 */
        margin: 0 auto;
    }
    .addRoleDialog{
        max-width: 1000px; /* 设置最大宽度 */
        margin: 0 auto;
    }
</style>
